var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnFingerPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#1477EC",
    rx: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.106 11.713A6.654 6.654 0 0 0 16 9.333c-3.111 0-5.85 2.204-6.513 5.24a.833.833 0 1 0 1.628.355C11.612 12.652 13.666 11 16 11c1.48 0 2.876.65 3.83 1.785a.833.833 0 0 0 1.276-1.072zM21.833 15.167A.833.833 0 0 0 21 16v2.917a.833.833 0 0 0 1.667 0V16a.833.833 0 0 0-.834-.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.25c-.987 0-1.92.38-2.624 1.071a.834.834 0 0 0 1.166 1.19A2.07 2.07 0 0 1 16 13.918c1.149 0 2.083.934 2.083 2.083v4.583a.833.833 0 0 0 1.667 0V16A3.754 3.754 0 0 0 16 12.25zM13.083 15.167a.833.833 0 0 0-.833.833v4.583a.833.833 0 0 0 1.667 0V16a.833.833 0 0 0-.834-.833zM10.167 16.417a.833.833 0 0 0-.834.833v1.667a.833.833 0 0 0 1.667 0V17.25a.833.833 0 0 0-.833-.833zM16 19.333a.833.833 0 0 0-.833.834v1.666a.833.833 0 0 0 1.666 0v-1.666a.833.833 0 0 0-.833-.834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15.167a.833.833 0 0 0-.833.833v1.667a.833.833 0 0 0 1.666 0V16a.833.833 0 0 0-.833-.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.458 6H6v5h1.458V7.458H11V6H7.458zM26 7.458V6h-5v1.458h3.542V11H26V7.458zM6 24.542V26h5v-1.458H7.458V21H6v3.542zM24.542 26H26v-5h-1.458v3.542H21V26h3.542z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFingerPrint);
export default __webpack_public_path__ + "static/media/btn_fingerPrint.c0ce51edd4f74ed382bc332814f53a11.svg";
export { ForwardRef as ReactComponent };